<template>
  <div>
    <section id="players">
      <div class="is-parent is-vertical">
        <graph-table  defaultShow="true" id="ZoneExits" heading="Zone Exits" v-bind:headers="ZoneExitPlayerHeadings" v-bind:tableData="sortByZoneExitData">
        <template slot="filter">
          </template>
        <div slot="graph">
            <chart :type="'horizontalBar'" :data="chartStackedData" :options="stacked_options" style=""></chart>
          </div>
        </graph-table>
      </div>
    </section>
    <section id="players">
      <div class="is-parent is-vertical">
        <data-table  defaultShow="true" id="Zone" heading="Zone Entries" v-bind:headers="ZoneEntriesAutoPlayerHeadings" v-bind:tableData="sortByZoneEntriesAutoData">
          <div slot="graph">
            <chart :type="'horizontalBar'" :data="chartZoneEntriesData" :options="multi_options" style=""></chart>
          </div>
        </data-table>
      </div>
    </section>
  </div>
</template>
<script>
import DataTable from './data-table'
import SubTable from './sub-table'
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
import embeddedDataGraphVue from './embedded-data-graph.vue'
export default {
  components: {
    'data-table': DataTable,
    'graph-table': embeddedDataGraphVue,
    'sub-table': SubTable,
    Chart
  },
  data () {
    return {
      SituationOptions: [],
      SituationSelected: 0,
      FilterSelected: 'total',
      ExitFilterSelected: 'pass',
      ZoneEntriesAutoPlayerData: [],
      ZoneEntriesAutoPlayerHeadings: [
        'Player',
        'Controlled Success',
        'Controlled Fail',
        'Total Controlled',
        'Uncontrolled Success',
        'Uncontrolled Failed',
        'Uncontrolled Dump',
        'Offside',
        'Total Unontrolled'
      ],
      ZoneEntriesPlayerData: [],
      ZoneEntriesPlayerHeadings: [
        'Player',
        'Success',
        'Success AVG',
        'Success No Possesion',
        'Success No Possesion AVG',
        'Fail',
        'Fail AVG',
        'Total',
        'Total AVG'
      ],
      ZoneEntriesPlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'Success', value: 'success'},
        {text: 'Success AVG', value: 'success_avg'},
        {text: 'Success With Pos', value: 'success_with_pos'},
        {text: 'Success With Pos AVG', value: 'success_with_pos_avg'},
        {text: 'Fail', value: 'fail'},
        {text: 'Fail AVG', value: 'fail_avg'},
        {text: 'Total', value: 'total'},
        {text: 'Total AVG', value: 'total_avg'}
      ],
      ZoneExitPlayerData: [],
      ZoneExitPlayerHeadings: [
        'Player',
        'Success (PCD)',
        'Pass',
        'Carry',
        'Dump',
        'Clear W/Out Poss',
        'Icing',
        'Fail'
      ],
      ZoneExitPlayerFilters: [
        {text: 'Player', value: 'player'},
        {text: 'GP', value: 'gp'},
        {text: 'Pass', value: 'pass'},
        {text: 'Carry', value: 'carry'},
        {text: 'Dump', value: 'dump_success'},
        {text: 'Clear With Pos AVG', value: 'clear'},
        {text: 'Icing', value: 'icing'}
      ],
      bar_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,

        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      },
      stacked_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      multi_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          enabled: true
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              stacked: true
            }
          }],
          yAxes: [{
            categoryPercentage: 0.76,
            barPercentage: 1,
            ticks: {
              autoSkip: false,
              stacked: true
            },
            gridLines: {
              offsetGridLines: true
            }
          }]
        }
      }
    }
  },
  computed: {
    sortByZoneEntriesData: function () {
      return _.orderBy(this.ZoneEntriesPlayerData, 'total_success', ['desc'])
    },
    sortByZoneEntriesDataChart: function () {
      let orderedData = this.sortByZoneEntriesData
      return _.map(orderedData, this.FilterSelected)
    },
    sortByZoneExitData: function () {
      return _.orderBy(this.ZoneExitPlayerData, 'total_success', ['desc'])
    },
    sortByZoneExitDataChart: function () {
      let orderedData = this.ZoneExitPlayerData
      return _.map(orderedData, 'total_success')
    },
    sortByZoneEntriesAutoData: function () {
      return _.orderBy(this.ZoneEntriesAutoPlayerData, 'controlled_total', ['desc'])
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.sortByZoneEntriesData) {
        playerLabels.push(label.player)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.sortByZoneEntriesAutoData,
        label: 'Zone Entry - ' + this.FilterSelected,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    },
    chartStackedData: function () {
      let playerLabels = []
      for (var label of this.sortByZoneExitData) {
        playerLabels.push(label.player)
      }
      let pass = []
      let carry = []
      let dumpWithPoss = []
      let clear = []
      let icing = []
      let fail = []
      for (var d of this.sortByZoneExitData) {
        pass.push(d.pass)
        carry.push(d.carry)
        dumpWithPoss.push(d.dump_success)
        clear.push(d.clear)
        icing.push(-d.icing)
        fail.push(-d.fail)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: pass,
        label: 'Pass',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf'
      },
      {
        data: carry,
        label: 'Carry',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7'
      },
      {
        data: dumpWithPoss,
        label: 'Dump With Poss',
        backgroundColor: '#00d4df',
        borderColor: '#00d4df'
      },
      {
        data: clear,
        label: 'Clear',
        backgroundColor: '#73fac9',
        borderColor: '#73fac9'
      },
      {
        data: icing,
        label: 'Icing',
        backgroundColor: '#9a4e96',
        borderColor: '#9a4e96'
      },
      {
        data: fail,
        label: 'Failed Exit',
        backgroundColor: '#a53169',
        borderColor: '#a53169'
      }]
      return data
    },
    chartZoneEntriesData: function () {
      let playerLabels = []
      for (var label of this.sortByZoneEntriesAutoData) {
        playerLabels.push(label.player)
      }
      let controlledSuccess = []
      let controlledFailed = []
      let controlledOffside = []
      let uncontrolledSuccess = []
      let uncontrolledFailed = []
      let uncontrolledOffside = []
      let uncontrolledDump = []
      for (var d of this.sortByZoneEntriesAutoData) {
        controlledSuccess.push(d.controlled_success)
        controlledFailed.push(-d.controlled_failed)
        controlledOffside.push(d.controlled_offside)
        uncontrolledSuccess.push(d.uncontrolled_success)
        uncontrolledFailed.push(-d.uncontrolled_failed)
        uncontrolledOffside.push(-d.offside)
        uncontrolledDump.push(-d.uncontrolled_dump)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: controlledSuccess,
        label: 'Controlled Success',
        backgroundColor: '#0077cf',
        borderColor: '#0077cf',
        stack: 'Controlled'
      },
      {
        data: controlledFailed,
        label: 'Controlled Failed',
        backgroundColor: '#00a9e7',
        borderColor: '#00a9e7',
        stack: 'Controlled'
      },
      {
        data: uncontrolledSuccess,
        label: 'Uncontrolled Success',
        backgroundColor: '#ff9677',
        borderColor: '#ff9677',
        stack: 'Uncontrolled'
      },
      {
        data: uncontrolledFailed,
        label: 'Uncontrolled Failed',
        backgroundColor: '#ff7298',
        borderColor: '#ff7298',
        stack: 'Uncontrolled'
      },
      {
        data: uncontrolledOffside,
        label: 'Offside',
        backgroundColor: '#c765b3',
        borderColor: '#c765b3',
        stack: 'Uncontrolled'
      },
      {
        data: uncontrolledDump,
        label: 'Uncontrolled Dump',
        backgroundColor: '#7263bb',
        borderColor: '#7263bb',
        stack: 'Uncontrolled'
      }]
      return data
    }
  },
  methods: {
    fetchSeasonStats () {
      let postData = {
        'game_id': this.$route.params.gameId,
        'situation': this.SituationSelected
      }
      console.log('Filter: ' + JSON.stringify(postData))
      this.$http
        .post('https://devilsapi.roblutken.com/api/app/get/match-stats/zone-entries', postData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
        }).then(
          response => {
            console.log(response.data)
            this.ZoneExitPlayerData = response.data.zone_exits
            this.ZoneEntriesAutoPlayerData = response.data.zone_entries
            console.log(response.data.zone_exits)
          },
          response => {}
        )
    },
    fetchFilterOptions () {
      this.SituationOptions.push({text: 'All', value: 0})
      this.SituationOptions.push({text: 'Even Handed', value: 1})
      this.SituationOptions.push({text: 'Power Play', value: 2})
      this.SituationOptions.push({text: 'Short Handed', value: 3})
      this.SituationOptions.push({text: 'Empty Net', value: 4})

      this.TypeOptions.push({text: 'All', value: ''})
      this.TypeOptions.push({text: 'Carry', value: 'Carry'})
      this.TypeOptions.push({text: 'Dump', value: 'Dump'})

      this.ZoneOptions.push({text: 'All', value: ''})
      this.ZoneOptions.push({text: 'Offensive', value: 'Offensive'})
      this.ZoneOptions.push({text: 'Defensive Exit', value: 'DefensiveExit'})
    }
  },
  mounted () {
    this.fetchSeasonStats()
    this.fetchFilterOptions()
  }
}
</script>
<style>
#fixed-div {
    position: fixed;
    top: 1em;
    right: 1em;
}
</style>



// WEBPACK FOOTER //
// zone-entries-game.vue?0bac040e